import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import React from 'react'
import { BillPayDataGridRow } from 'src/components/BillPayDataGrid/BillPayDataGrid'
import DataGridCell from 'src/components/DataGrid/cells/DataGridCell/DataGridCell'

export const renderVendorNameCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      text={vc.billPayMeta?.vendorName}
      params={params}
    />
  )
}

export const renderVendorEmailCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      text={vc.billPayVendorEmail}
      params={params}
    />
  )
}

export const renderCardCreatorCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      // TODO: can't use fullNameOrEmail for some reason
      text={`${vc.cardholder?.firstName} ${vc.cardholder?.lastName}`}
      params={params}
    />
  )
}

export const renderSentDateCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      text={vc.sharedDateTimezonedString}
      params={params}
    />
  )
}

export const renderInvoiceDateCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      text={vc.invoiceDateTimezonedString}
      params={params}
    />
  )
}

export const renderInvoiceNumberCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      text={vc.billPayMeta?.invoiceNumber}
      params={params}
    />
  )
}

export const renderInvoiceAmountCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      text={vc.limitLabel}
      params={params}
    />
  )
}

export const renderAvailableCreditCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending || vc.isInactive}
      text={vc.isInactive ? undefined : vc.balanceLabel}
      params={params}
    />
  )
}

export const renderActiveUntilCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  return (
    <DataGridCell
      disabled={vc.isPending}
      color={vc.isInactive ? 'severe' : undefined}
      text={
        vc.isInactive
          ? vc.inactiveSinceTimezonedString
          : vc.activeUntilTimezonedString
      }
      params={params}
    />
  )
}

export const renderStatusCell = (
  params: GridRenderCellParams<BillPayDataGridRow>,
): React.ReactElement => {
  const vc = params.row.virtualCard
  const getColor = () => {
    if (vc.isActive) {
      return 'highlight'
    } else if (vc.isInactive) {
      return 'severe'
    }
  }
  return (
    <DataGridCell
      disabled={vc.isPending}
      color={getColor()}
      text={vc.psuedoStatusLabel}
      params={params}
    />
  )
}
